window.commentReplayShow = function() {
        document.querySelectorAll(".comment-replay-show").forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault();
                var show = this.getAttribute('data-replay-show-id');
                document.querySelectorAll(".comment-replay-to-" + show).forEach(el2 => {
                    el2.classList.remove('hidden');

                });
                event.target.remove();
            }, false);
        });
    }

window.commentDestroy = function () {
        document.querySelectorAll("#comments-box .destroy-comment").forEach(el => {
            el.addEventListener('click', function(event) {
                event.preventDefault();
                if( !confirm('Delete?') ) return;
                var href = event.target.getAttribute("data-href");
                var comment = event.target.getAttribute("data-comment-id");

                axios.delete(href)
                    .then(function (response) {
                        //showNotification(response.data);
                        if(response.data.success) {
                            document.getElementById(comment).remove();
                        }
                    });

            }, false);
        });
    }

window.commentPagination = function () {
        document.querySelectorAll("#comments-box .pagination a").forEach(el => {
            el.addEventListener('click', function(event) {
                event.preventDefault();
                var href = event.target.getAttribute("href");
                if(href != "#") {
                    axios.post(href)
                        .then(function (response) {
                            if(response.data.success) {
                                commentSuccess(response.data);
                            }
                        });
                }
            }, false);
        });
    }
    commentPagination();
    commentDestroy();
    commentReplayShow();

window.commentSuccess = function(data) {
         document.getElementById("comments-box").innerHTML = data.comments;
         commentPagination();
         commentDestroy();
         initAjaxForm();
         commentReplayShow();
         if(document.querySelector(".modal-backdrop")) document.querySelector(".modal-backdrop").remove();
    }